export const BUILDINGS = '/buildings';
export const BUILDING_DETAILS = '/building/details/:id';
export const NEW_BUILDING = '/building/new';
export const UPDATE_BUILDING = '/building/update/:id';
